import { Moon, Sun } from 'lucide-react'

import { useTheme } from '../lib/theme'

export function ThemeToggle({ className }: { className?: string }) {
  const [theme, toggleTheme] = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      className={`theme-toggle${className ? ` ${className}` : ''}`}
      onClick={toggleTheme}
      aria-label={isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      aria-pressed={isDark}
      data-theme-toggle={theme}
    >
      <span className="theme-toggle__knob">
        {isDark ? <Moon size={11} /> : <Sun size={11} />}
      </span>
    </button>
  )
}
